interface HeaderProps {
  children: JSX.Element | JSX.Element[] | undefined;
}

const Header = ({ children }: HeaderProps) => (
  <div className="header d-flex flex-column">{children && children}</div>
);

export default Header;
